module.exports = __webpack_public_path__ + ".htaccess";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/.htaccess
// module id = 202
// module chunks = 15